import { useContext, useState } from "react";
import { Box, Grid, List, Typography, Hidden } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { UserContext } from "@/contexts/user";

import { useConfig } from "@/contexts/config";
import { pagesConfig } from "@/router/pagesConfig";
import LocaleSelector from "@/components/LocaleSelector";
import LogoutBtn from "./LogoutBtn";
import Item from "./Item/index";
import useStyles from "./style";

const Sidebar = () => {
  const classes = useStyles();
  const [userState] = useContext(UserContext);
  const { t } = useTranslation();
  const { config } = useConfig();
  const [openParentLabel, setOpenParentLabel] = useState(null);

  const identifiantUser = `${userState?.name ?? ""} ${
    userState?.user?.codeUser?.replace("_", " ") ?? ""
  }`.trim();

  const hasVisibleDescendant = (item) => {
    if (item.subItems && item.subItems.length > 0) {
      return item.subItems.some(hasVisibleDescendant);
    }
    return !!(item.sidebarShow && item.component != null);
  };

  return (
    <Grid
      style={{ height: "100%" }}
      container
      direction="column"
      justifyContent="space-between"
    >
      <Box className={classes.content}>
        <Hidden smDown implementation="css">
          <Grid container justifyContent="center">
            <Box>
              <img
                src={`${localStorage.getItem(
                  "IMAGE_MANAGER_URL_GET"
                )}/assurimo/base/logo-assurimo.png`}
                alt="Assurimo"
                style={{
                  maxWidth: 220,
                }}
              />
            </Box>
          </Grid>
        </Hidden>
        <Grid container justifyContent="flex-start">
          <Box
            my={4}
            px={2}
            style={{ marginLeft: 16, marginTop: 20, marginBottom: 20 }}
          >
            <Typography variant="subtitle2">
              <span style={{ fontWeight: "bold" }}>{identifiantUser}</span>
            </Typography>
          </Box>
        </Grid>
        <List>
          {pagesConfig(t, config)
            .filter((e) => hasVisibleDescendant(e) || e.sidebarShow)
            .map((item, i) => (
              <Item
                key={i}
                item={item}
                openParentLabel={openParentLabel}
                setOpenParentLabel={setOpenParentLabel}
              />
            ))}
        </List>
      </Box>
      <Box pb={4}>
        <List>
          <LocaleSelector variant="sidebar" />
          <LogoutBtn />
        </List>
      </Box>
    </Grid>
  );
};

export default Sidebar;
